// Types for province.json structure
export interface Village { code: string; khmer: string; latin: string; }
export interface Commune { code: string; khmer: string; latin: string; villages: Village[]; }
export interface District { code: string; khmer: string; latin: string; communes: Commune[]; }
export interface Province { code: string; khmer: string; latin: string; districts: District[]; }

// Utility functions to get label from province.json structure
export function getProvinceLabel(provincesData: Province[], provinceCode: string) {
  return provincesData.find((p: Province) => p.code === provinceCode)?.latin || provinceCode || "N/A";
}

export function getDistrictLabel(provincesData: Province[], provinceCode: string, districtCode: string) {
  return provincesData
    .find((p: Province) => p.code === provinceCode)?.districts
    ?.find((d: District) => d.code === districtCode)?.latin || districtCode || "N/A";
}

export function getCommuneLabel(provincesData: Province[], provinceCode: string, districtCode: string, communeCode: string) {
  return provincesData
    .find((p: Province) => p.code === provinceCode)?.districts
    ?.find((d: District) => d.code === districtCode)?.communes
    ?.find((c: Commune) => c.code === communeCode)?.latin || communeCode || "N/A";
}

export function getVillageLabel(provincesData: Province[], provinceCode: string, districtCode: string, communeCode: string, villageCode: string) {
  return provincesData
    .find((p: Province) => p.code === provinceCode)?.districts
    ?.find((d: District) => d.code === districtCode)?.communes
    ?.find((c: Commune) => c.code === communeCode)?.villages
    ?.find((v: Village) => v.code === villageCode)?.latin || villageCode || "N/A";
}